import { render, staticRenderFns } from "./WithdrawalFeeCell.vue?vue&type=template&id=3baea686&"
import script from "./WithdrawalFeeCell.vue?vue&type=script&lang=js&"
export * from "./WithdrawalFeeCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports